import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const conceptApi = createApi({
  reducerPath: "conceptApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_URL}/v1/userservice`,
    validateStatus: (response) => {
      if (response.status === 401) {
        window.location.href = "/login";
        return false;
      } else if (response.status >= 200 && response.status < 300) {
        return true;
      } else {
        throw new Error(`HTTP error ${response.status}`);
      }
    },
  }),
  endpoints: (builder) => ({
    getAllConcept: builder.mutation({
      query: (body) => ({
        url: "/v1/userservice/api/user/getActiveConcepts",
        method: "POST",
        body: body,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }),
    }),
    createConcept: builder.mutation({
      query: (body) => ({
        url: "/v1/userservice/api/user/createConcept",
        method: "POST",
        body: body,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }),
    }),
  }),
});

export const { useGetAllConceptMutation, useCreateConceptMutation } =
  conceptApi;
